import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {flexGrow: 1, paddingBottom: indent * 2},

  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: indent * 0.7,
    marginLeft: indent,
    marginRight: indent * 0.8,
  },
  headerText: {
    fontWeight: 'bold',
    fontSize: 16,
    flex: 1,
  },
  showHideButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  showHideButton: {
    color: denim,
    marginRight: indent / 2,
    fontWeight: '600',
  },
  icon: {
    fontSize: 18.5,
    fontWeight: '600',
    alignSelf: 'flex-end',
  },
});
